import React from 'react';

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <p className="text-red-800">{error}</p>
      <button onClick={onRetry} className="mt-2 text-sm text-red-600 hover:text-red-800 underline">
        Try again
      </button>
    </div>
  );
};
